export default __webpack_public_path__ + "static/salon-deals-logo~xOhOquqS-cf7a31b7dcf5d4c6a86c07efa997ae21.png";